import { clamp } from 'utils/numbers'

export function getAwardedVolume(proposals: LaneProposal[]) {
  return proposals.reduce(
    (total, { awarded_type, awarded_volume }) =>
      awarded_type === 'primary' ? total + awarded_volume : total,
    0
  )
}

export function calculateSuggestedVolume({
  proposals,
  lane,
  proposal,
}: {
  lane: Lane
  proposal: LaneProposal
  proposals: LaneProposal[]
}) {
  const awardedVolume = getAwardedVolume(proposals)
  return clamp(lane.volume - awardedVolume, 0, proposal.capacity)
}

export function getAverageRatePrice(proposals: LaneProposal[]) {
  const awardedProposals = proposals.filter(
    ({ awarded_type }) => !!awarded_type
  )
  if (!awardedProposals.length) {
    return 0
  }
  const add = (...n: number[]) => n.reduce((total, n) => total + n, 0)
  const total = add(
    ...awardedProposals.map(({ rate_price }) => Number(rate_price))
  )
  return total / awardedProposals.length
}

export function getHighestBid(proposals: LaneProposal[]) {
  return Math.max(...proposals.map(({ rate_price }) => Number(rate_price)))
}

export function getLowestBid(proposals: LaneProposal[]) {
  return Math.min(...proposals.map(({ rate_price }) => Number(rate_price)))
}
